<script>
import Base from '@/plans/ZONE_EDU_PLUS/config/base';
import { planTypes } from '@/common/constants';

export default {
  extends: Base,
  key: planTypes[planTypes.ZONE_EDU_PLUS],
};
</script>
